/* jshint esversion: 6 */
import React from 'react';
import ChooserHeader from 'app/components/SubaccountSelector/ChooserHeader.jsx';
import ChooserMain from 'app/components/SubaccountSelector/ChooserMain.jsx';

class LinkedInOutput extends React.Component {
    render() {
        return (
            <div>
                <ChooserHeader
                    error={this.props.error}
                    headerCopy="Select a LinkedIn Person or Company Page"/>
                <ChooserMain
                    {...this.props}/>
            </div>
        );
    }
}

LinkedInOutput.displayName = "LinkedInOutput";

export default LinkedInOutput;
